import emailjs from "@emailjs/browser";
const state = {
  sendingEmail: false,
  emailSent: false,
  emailError: null,
};

const getters = {
  StateSendingEmail: (state) => state.sendingEmail,
  StateEmailSent: (state) => state.emailSent,
  StateEmailError: (state) => state.emailError,
};

const mutations = {
  setSendingEmail(state, value) {
    state.sendingEmail = value;
  },
  setEmailSent(state, value) {
    state.emailSent = value;
  },
  setEmailError(state, error) {
    state.emailError = error;
  },
};

const actions = {
  SendContactEmail({ commit }, data) {
    const userId = "T6chbXldV3j6__54F";
    const serviceId = "lmxitti_contact";
    const templateId = "template_cm9h4jg";

    commit("setSendingEmail", true);
    commit("setEmailSent", false);
    commit("setEmailError", null);

    emailjs
      .sendForm(serviceId, templateId, data, userId)
      .then(() => {
        commit("setSendingEmail", false);
        commit("setEmailSent", true);
        commit("setEmailError", null);
      })
      .catch((error) => {
        commit("setSendingEmail", false);
        commit("setEmailSent", false);
        commit("setEmailError", error);
      });
  },

  SendCallMeMail({ commit }, data) {
    const userId = "T6chbXldV3j6__54F";
    const serviceId = "lmxitti_contact";
    const templateId = "template_pb6q1mi";

    commit("setSendingEmail", true);
    commit("setEmailSent", false);
    commit("setEmailError", null);

    emailjs
      .sendForm(serviceId, templateId, data, userId)
      .then(() => {
        commit("setSendingEmail", false);
        commit("setEmailSent", true);
        commit("setEmailError", null);
      })
      .catch((error) => {
        commit("setSendingEmail", false);
        commit("setEmailSent", false);
        commit("setEmailError", error);
      });
  },
  SendBookingMail({ commit }, data) {
    const userId = "T6chbXldV3j6__54F";
    const serviceId = "lmxitti_contact";
    const templateId = "template_pb6q1mi";

    commit("setSendingEmail", true);
    commit("setEmailSent", false);
    commit("setEmailError", null);

    emailjs
      .sendForm(serviceId, templateId, data, userId)
      .then(() => {
        commit("setSendingEmail", false);
        commit("setEmailSent", true);
        commit("setEmailError", null);
      })
      .catch((error) => {
        commit("setSendingEmail", false);
        commit("setEmailSent", false);
        commit("setEmailError", error);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
